import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";

export default function AiImageButton({ title, sector, description, onGenerated, testid = "ai-image-btn" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!title || title.trim().length < 2) return toast.error("Renseignez d'abord le nom de l'entreprise.");
    setBusy(true);
    try {
      const { data } = await api.post("/admin/generate-image", { title, sector: sector || "", description: (description || "").slice(0, 4000) });
      onGenerated(data.url); toast.success("Image générée");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Génération impossible."); }
    setBusy(false);
  };
  return (
    <button type="button" onClick={run} disabled={busy} data-testid={testid}
      className="inline-flex items-center gap-2 border border-[#E0C173] text-[#1B2A4A] text-sm px-4 py-2 rounded-full hover:bg-[#E0C173] disabled:opacity-60 transition-colors">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} {busy ? "Génération… (≈ 15 s)" : "Générer une image par IA"}
    </button>
  );
}
